import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { StockMovementsState } from './StockMovementsTypes'

const selectFeature = (state: State) => state.stockMovements

export const selectMovements = createSelector(
  selectFeature,
  (state: StockMovementsState) => state.movements,
)

export const selectHasNextPage = createSelector(
  selectFeature,
  (state: StockMovementsState) => state.movements.length < state.totalItems,
)

export const selectFilters = createSelector(
  selectFeature,
  (state: StockMovementsState) => state.filters,
)
